import { render, staticRenderFns } from "./PolicyMedicinesCheckList.vue?vue&type=template&id=06be19e3"
import script from "./PolicyMedicinesCheckList.js?vue&type=script&lang=js&external"
export * from "./PolicyMedicinesCheckList.js?vue&type=script&lang=js&external"
import style0 from "./PolicyMedicinesCheckList.vue?vue&type=style&index=0&id=06be19e3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports